import { render, staticRenderFns } from "./Pembelian.vue?vue&type=template&id=766d1f3f&"
import script from "./Pembelian.vue?vue&type=script&lang=js&"
export * from "./Pembelian.vue?vue&type=script&lang=js&"
import style0 from "./Pembelian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports